var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade-in-down" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        class: _vm.classes
      },
      [
        _c("img", { staticClass: "icon", attrs: { src: _vm.icon, alt: "" } }),
        _vm._v(" "),
        _vm._t("default", [
          !_vm.dangerouslyUseHTMLString
            ? _c("p", { staticClass: "el-message__content" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.content) + "\n\t\t\t")
              ])
            : _c("p", {
                staticClass: "el-message__content",
                domProps: { innerHTML: _vm._s(_vm.content) }
              })
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }